import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Card, Spin } from 'antd';

import React, { useEffect } from 'react';
import '../../../../../styles/pages/warehouse/_settlement/index.scss';
import '../../../../../styles/abstracts/_variables.scss';
import TableBilling from '../components/TableBilling';
import TransactionAmount from '../../components/TransactionAmount';
import { useActions } from '@root/core/hooks/useActions';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';

const Breadcrumb = [
  {
    tittle: 'Settlement',
    url: ''
  },
  {
    tittle: 'Billing Inquiry',
    url: ''
  }
];

const BillingInquiryPage = () => {
  // transaction amount api
  const { getTransactionInfo } = useActions();

  useEffect(() => {
    getTransactionInfo();
  }, []);
  const { amount } = useTypedSelector((state) => state.amountInfoReducer);

  const { loading } = useTypedSelector((state) => state.settlementReducer);
  return (
    <>
      <Spin spinning={loading}>
        <BreadcrumbList listBreadcrumb={Breadcrumb} />
        <div className="admin-container ">
          <Card
            bordered={false}
            className="admin-card"
            style={{
              minHeight: '80vh',
              background: 'none'
            }}
          >
            <div className="billingInquiry">
              <TransactionAmount amountInfo={amount?.data} />
              <TableBilling />
            </div>
          </Card>
        </div>
      </Spin>
    </>
  );
};

export default BillingInquiryPage;
